import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce5999f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["enter"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "16",
  viewBox: "0 0 25 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM25 7L1 7V9L25 9V7Z",
    fill: "white"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "k-rank-meter__player-color" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Your color is currently ")
const _hoisted_6 = { style: {"font-weight":"500"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_8 = {
  key: 0,
  class: "k-rank-meter__player-stats"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Your final score was ")
const _hoisted_10 = { style: {"font-weight":"500"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" and you performed better than around ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" of other players. ")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" This was not your best match. ")
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" This was ")
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" your best match yet! ")
const _hoisted_24 = {
  key: 2,
  style: {"color":"#4bff4b"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = {
  key: 1,
  class: "k-rank-meter__player-stats"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Your highest score was ")
const _hoisted_28 = { style: {"font-weight":"500"} }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(", performing better than around ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" of other players. ")
const _hoisted_31 = {
  key: 0,
  style: {"color":"#4bff4b"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { onBeforeUnmount, reactive, ref } from 'vue';
import { useMotion } from '@vueuse/motion'
import { useModule } from 'src/modules/modules';
import { clamp, sample } from 'lodash';
import ordinal from 'ordinal';
import chroma from 'chroma-js';
import { nameColor } from 'src/color-namer/color-namer'; 
import toLower from 'lodash/toLower';
import startCase from 'lodash/startCase';
import ntc from 'src/color-namer/ntc';
import { RankedPersistedStats } from 'src/types/game.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'rank-meter',
  props: {
    context: null,
    stats: null
  },
  setup(__props: any) {

const { stats, context } = __props as {
    context?: 'rank' | 'best',
    stats: RankedPersistedStats
}

_useCssVars(_ctx => ({
  "fac48d8e": (meterPos.value)
}))

const { global, game } = useModule();


const titleCase = (str: string) => startCase(toLower(str));

const colors = ['#00FF47', '#00D1FF', '#DB00FF', '#FF9900', '#FF0000'];
const f = chroma.scale(colors);
const playerColorHex = ref(f(1 - stats.rankPercentile).toString());
const names = nameColor(playerColorHex.value, { pick: ['ntc'], distance: 'deltaE' });
const playerColorName = ref<string>(titleCase(names[0].name));

if (playerColorName.value.toLowerCase() === 'red'){
    //playerColorName.value = 'Blood Red'
} else if (playerColorName.value.toLowerCase() === 'green'){
    playerColorName.value = 'Champion Green'
}

//game.setBackgroundColor(chroma(playerColorHex.value).darken(6.5));

const percentileLabel = `${Math.floor(stats.rankPercentile * 100)}%`;

const duration = 3000;
const meterPos = ref(`calc(${clamp((1 - stats.rankPercentile) * 100, 1, 99)}% - 8px)`);
const meter = ref();
const container = ref<HTMLElement>();
const arrow = ref<HTMLElement>();
const content = ref<HTMLElement>();
const playerColorEl = ref<HTMLElement>();

const rankCounter = reactive({
    final: stats.matchRank,
    count: 0,
    from: stats.rankPercentile < .5 ? 1 : stats.rankCount
})

const fxBackgroundTimeout = window.setTimeout(() => {
    game.startBackgroundFx(
       // Phaser.Display.Color.HexStringToColor(playerColorHex.value).color
    )
}, duration);

onBeforeUnmount(() => {
    clearTimeout(fxBackgroundTimeout);
})

function shuffleChars(str: string): string {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < str.length; i++) {
        if (str[i] === ' ') {
            result += ' ';
        } else {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
    }
    return result;
}

const entered = ref(false);
const enter = () => {
    if (entered.value) return;
        entered.value = true;

    if (content.value && container.value && arrow.value && content.value){
        let containerRect = container.value?.getBoundingClientRect();
        let arrowRect = arrow.value?.getBoundingClientRect();
        let contentRect = content.value?.getBoundingClientRect();
        let maxHeight = (containerRect.bottom - containerRect.top) - (contentRect.height);

        let top = (arrowRect.bottom - (arrowRect.height / 2)) - (contentRect.height / 2) - containerRect.top;
            top = clamp(top, 0, maxHeight)

        content.value.style.left = `${arrowRect.right - containerRect.left + 5}px`;
        content.value.style.top = `${top}px`;

        let arrowStartPosY = containerRect.height - top;
        if (stats.rankPercentile <= .5){
            arrowStartPosY = -(containerRect.height * (top / containerRect.height));
        }

        const arrowMotion = useMotion(arrow, {
            initial: {
                opacity: 0,
                y: arrowStartPosY
            },
            enter: {
                opacity: 1,
                y: 0,
                transition: {
                    duration: duration,
                    ease: 'easeOut'
                }
            }
        })

        const contentMotion = useMotion(content, {
            initial: {
                opacity: 0,
                y: arrowStartPosY
            },
            enter: {
                opacity: 1,
                y: 0,
                transition: {
                    duration: duration,
                    ease: 'easeOut'
                }
            }
        })

        
        let originalPlayerColorName = playerColorName.value;
        let originalPlayerColorHex = playerColorHex.value;
        rankCounter.count = rankCounter.from;
        let step = Math.floor(rankCounter.final / 75), throttleCounter = 0;

        let proxyCounter = { count: rankCounter.from }
        global.sceneState.scene?.add.tween({
            targets: proxyCounter,
            count: rankCounter.final,
            duration: duration,
            ease: Phaser.Math.Easing.Cubic.Out,
            onUpdate: (tween) => {
                rankCounter.count = Math.floor(tween.getValue());
                throttleCounter += 1;
                if (throttleCounter % step === 0 && playerColorEl.value){
                    let color = sample(ntc)!;
                    playerColorEl.value.style.color = color.hex;
                    playerColorEl.value.innerText = shuffleChars(originalPlayerColorName);  //color.name;
                }
            },
            onComplete: () => {
                if (playerColorEl.value){
                    playerColorEl.value.style.color = originalPlayerColorHex;
                    playerColorEl.value.innerText = originalPlayerColorName;
                }
            },
        })
    }
}

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "k-rank-meter"
  }, [
    _withDirectives(_createElementVNode("div", {
      ref_key: "meter",
      ref: meter,
      class: "k-rank-meter__meter",
      initial: {
                opacity: 0,
                x: -300
            },
      enter: {
                opacity: 1,
                x: 0,
                transition: {
                    duration: 500,
                    ease: 'easeOut',
                    onComplete: () => enter()
                },
            }
    }, null, 8, _hoisted_1), [
      [_directive_motion]
    ]),
    _createElementVNode("div", {
      ref_key: "arrow",
      ref: arrow,
      class: "k-rank-meter__pos flex-centered"
    }, _hoisted_3, 512),
    _createElementVNode("div", {
      ref_key: "content",
      ref: content,
      class: "k-rank-meter__content"
    }, [
      _createElementVNode("label", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, [
          _createElementVNode("span", {
            ref_key: "playerColorEl",
            ref: playerColorEl
          }, null, 512)
        ]),
        _hoisted_7
      ]),
      (__props.context === 'rank')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(__props.stats.score), 1),
            _hoisted_11,
            _createElementVNode("span", { style: {"font-weight":"500"} }, _toDisplayString(percentileLabel)),
            _hoisted_12,
            (__props.stats.matchRank > __props.stats.overrallRank)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_17))
              : (__props.stats.matchRank <= __props.stats.overrallRank)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21,
                    (__props.stats.rankPercentile <= .025)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "(believe it or not)"))
                      : _createCommentVNode("", true),
                    _hoisted_23
                  ]))
                : _createCommentVNode("", true),
            (__props.stats.matchRank <= 50)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createTextVNode(" You ranked in the top 50! You're current rank is " + _toDisplayString(_unref(ordinal)(Math.floor(rankCounter.count))) + ". Nice. ", 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("span", _hoisted_28, _toDisplayString(__props.stats.score), 1),
            _hoisted_29,
            _createElementVNode("span", { style: {"font-weight":"500"} }, _toDisplayString(percentileLabel)),
            _hoisted_30,
            (__props.stats.matchRank <= 50)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _hoisted_32,
                  _createTextVNode(" You're ranked in the top 50 with a rank of " + _toDisplayString(_unref(ordinal)(Math.floor(rankCounter.count))) + ". Nice. ", 1)
                ]))
              : _createCommentVNode("", true)
          ]))
    ], 512)
  ], 512))
}
}

})